import { graphql } from "gatsby"
import React, { useRef, useState } from "react"
import FlutterCaseStudy from "../components/FlutterCaseStudy/FlutterCaseStudy"
import Header from "../components/header/header"
import Seo from "../components/seo"
import Techstacks from "../components/newComponents/techstacks/techstacks"
import WebinarBanner from "../components/webinarBanner/webinarBanner"
import WebinarCalendar from "../components/webinarCalendar/webinarCalendar"
import WebinarService from "../components/webinarService/webinarService"
import WebinarSolution from "../components/webinarSolution/webinarSolution"
import CallSection from "../components/webinarseatSection/webinarseat"
import WebinarForm from "../components/WebinarForm/WebinarForm"
import { replaceUnderscoresWithSpaces } from "../utils/functions"
import { useHomeNewMetadata } from "../queries/useHomeNewMetaData"
import Footer from "../components/newComponents/footer/footer"
import CliensPartners from "../components/newComponents/cliensPartners/cliensPartners"

const Webinar = ({ data }) => {
  const [activeId, setActiveId] = useState(null)
  const [isLoggedIn] = useState()
  const elementRef = useRef(null)

  const homeData = useHomeNewMetadata()
  const {
    wpPage: { slug, MetaFields, WebinarFields },
  } = data

  const scrollToElement = () => {
    if (elementRef.current) {
      window.scrollTo({
        behavior: "smooth",
        top: elementRef.current.offsetTop - 97,
      })
    }
  }

  const handleClick = id => {
    // TODO: Specific condition for this webinar remove this after this webinar
    if (
      window.location.pathname ===
      `/navigating-the-cybersecurity-landscape-custom-software-engineering-and-securing-critical-infrastructure/`
    ) {
      window.open(
        "https://www.eventbrite.com/e/lunch-learn-cybersecurity-in-custom-software-engineering-tickets-1048148649827",
        "_blank"
      )
      return
    }

    setActiveId(id)
    scrollToElement()
  }

  const seoData = {
    customSeoMetaTitle: MetaFields.customSeoMetaTitle,
    customSeoMetaDescription: MetaFields.customSeoMetaDescription,
    customSeoOgUrl: MetaFields.customSeoOgUrl,
    customSeoRobotFollow: MetaFields.customSeoRobotFollow,
    customSeoRobotIndex: MetaFields.customSeoRobotIndex,
    customSeoKeywords: MetaFields.customSeoKeywords,
  }

  const {
    homeTechTitle,
    homeTechShowSection,
    homeTechSubTitle,
    
    homeWorkContent,
    homeWorkShowSection,
    homeWorkSubTitle,
    homeWorkTitle,
    homeNewWorkLogoList,
  } = homeData?.wpPage?.homePageNewFields

  const {
    bannerButtonTitle,
    bannerSubtitle,
    bannerText,
    bannerTitle,
    bannerImage,
    speakersTag,
    speakersTitle,
    speakersList,
    leverageTitle,
    leverageDescription,
    keyTakeaways,
    leverageImage,
    embraceItTitle,
    youtubeLink,
    embraceItDescription,
    embraceItButtonText,
    embraceItSectionLeftImage,
    embraceItSectionLeftTitle,
    embraceItSectionLeftSubtitleTag,
    insightsDescription,
    insightsLink,
    insightsTitle,
    projectsTitle,
    projectsLink,
    projectsDesctiption,
    leverageKeytakeawayTitle,
    addToCalenderLink,
    leverageTag,
    joinWebinarQuote,
    comingSoonWebinar,
  } = WebinarFields

  return (
    <>
      <Seo
        title={MetaFields.customSeoMetaTitle}
        bannerImage={bannerImage?.mediaItemUrl}
        seoData={seoData}
      />
      
      <Header headerClass="webinar-header red-header" homeData={homeData?.wp} />

      <WebinarBanner
        bannerButtonTitle={bannerButtonTitle}
        bannerSubtitle={bannerSubtitle}
        bannerText={bannerText}
        bannerTitle={bannerTitle}
        bannerImage={bannerImage}
        isLoggedIn={isLoggedIn}
        handleClick={handleClick}
        comingSoonWebinar={comingSoonWebinar}
      />

      <WebinarSolution
        speakersTag={replaceUnderscoresWithSpaces(speakersTag)}
        speakersTitle={speakersTitle}
        speakersList={speakersList}
      />

      <WebinarCalendar
        leverageTitle={leverageTitle}
        leverageDescription={leverageDescription}
        keyTakeaways={keyTakeaways}
        leverageImage={leverageImage}
        leverageKeytakeawayTitle={leverageKeytakeawayTitle}
        addToCalenderLink={addToCalenderLink}
        leverageTag={replaceUnderscoresWithSpaces(leverageTag)}
        comingSoonWebinar={comingSoonWebinar}
      />

      <WebinarService
        embraceItTitle={embraceItTitle}
        embraceItDescription={embraceItDescription}
        embraceItButtonText={embraceItButtonText}
        embraceItSectionLeftImage={embraceItSectionLeftImage}
        embraceItSectionLeftTitle={embraceItSectionLeftTitle}
        embraceItSectionLeftSubtitleTag={embraceItSectionLeftSubtitleTag}
        insightsDescription={insightsDescription}
        insightsLink={insightsLink}
        insightsTitle={replaceUnderscoresWithSpaces(insightsTitle)}
        projectsTitle={replaceUnderscoresWithSpaces(projectsTitle)}
        projectsLink={projectsLink}
        projectsDesctiption={projectsDesctiption}
        comingSoonWebinar={comingSoonWebinar}
        youtubeLink={youtubeLink}
      />
      
      <WebinarForm
        slug={slug}
        homeData={homeData.wp}
        CustomClass="ph-100"
        elementRef={elementRef}
        activeId={activeId}
        comingSoonWebinar={comingSoonWebinar}
      />

      <FlutterCaseStudy />

      <Techstacks
        homeTechTitle={homeTechTitle}
        homeTechShowSection={homeTechShowSection}
        homeTechSubTitle={homeTechSubTitle}
        technologyStack={homeData?.allWpTechnologyStack}
        technologyStackCategory={homeData?.allWpTechnologyStackCategory}
        CustomClass='section_bottom_padding'
      />

      <CallSection
        handleClick={handleClick}
        joinWebinarQuote={joinWebinarQuote}
        comingSoonWebinar={comingSoonWebinar}
      />

      <CliensPartners
        homeWorkContent={homeWorkContent}
        homeWorkLogoList={homeNewWorkLogoList}
        homeWorkShowSection={homeWorkShowSection}
        homeWorkSubTitle={homeWorkSubTitle}
        homeWorkTitle={homeWorkTitle}
        CustomClass='section_common_padding'
      />

      <Footer
        footerMenu={homeData?.wpMenu?.menuItems}
        homeData={homeData?.wp?.myThemeOptionsSettings}
      />
    </>
  )
}
export default Webinar

export const webinarLandingpage = graphql`
  query ServiceInfo($id: String) {
    wpPage(id: { eq: $id }) {
      id
      slug
      MetaFields {
        customPageSchema
        customSeoFocusKeyphrase
        customSeoKeywords
        customSeoMetaDescription
        customSeoMetaTitle
        customSeoOgUrl
        customSeoRobotFollow
        customSeoRobotIndex
        fieldGroupName
      }
      WebinarFields {
        bannerButtonTitle
        bannerSubtitle
        bannerText
        bannerTitle
        embraceItButtonText
        embraceItDescription
        embraceItSectionLeftSubtitleTag
        embraceItSectionLeftTitle
        embraceItTitle
        youtubeLink
        fieldGroupName
        insightsDescription
        insightsTitle
        leverageDescription
        leverageTitle
        projectsDesctiption
        projectsTitle
        speakersTag
        speakersTitle
        addToCalenderLink {
          url
          title
        }
        bannerButtonLink {
          url
          title
        }
        embraceItButtonLink {
          title
          url
        }
        embraceItSectionLeftImage {
          mediaItemUrl
          altText
        }
        insightsLink {
          title
          url
        }
        keyTakeaways {
          takewayPoint
        }
        leverageImage {
          mediaItemUrl
        }
        projectsLink {
          title
          url
        }
        speakersList {
          company
          designation
          fieldGroupName
          linkedProfileLink {
            title
            url
          }
          photo {
            mediaItemUrl
          }
          speakerName
        }
        bannerImage {
          altText
          mediaItemUrl
        }
        bannerTag
        leverageKeytakeawayTitle
        leverageTag
        joinWebinarQuote
        comingSoonWebinar
      }
    }
  }
`
